import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Helpers from '../../../../common/helpers';
import constants from '../../../../common/constants';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';

class LinkDisplay extends Component {
  formLinkUrl(campaign, language, profile, sites) {
    const username = profile && profile.user_name ? profile.user_name : '';
    const link = _.find(sites, { page_code: campaign.link_url });

    return link ? Helpers.formUrl(link, {
      reason: username,
      refcode: campaign.partner_code,
      code: campaign.partner_code,
    }, language) : '';
  }

  copyToClipboard(html) {
    const { toggleInfoModal } = this.props;

    Helpers.copyToClipboard(html);
    toggleInfoModal(true, constants.info_modal_types.success.value, 'DASHBOARD.COPY_BANNER_CODE_MESSAGE');
  }

  render() {
    const { t } = this.context;
    const { campaign, anchor, language, profile, sites } = this.props;
    const url = this.formLinkUrl(campaign, language, profile, sites);
    const html = Helpers.getUrlHtml(url, anchor);

    return (
      <div className="link-display-container">
        <pre className="m-t-10">
          <code>{html || ''}</code>
        </pre>
        <div className="transparent-btn" onClick={() => this.copyToClipboard(html)}>
          {t('DASHBOARD.GRAB_BANNER_CODE')}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  anchor: state.linkCreatorReducer.anchor,
  campaign: state.linkCreatorReducer.campaign,
  language: state.linkCreatorReducer.language,
  profile: state.userProfileReducer.profile,
  sites: state.linkCreatorReducer.sites,
});

const mapDispatchToProps = dispatch => ({
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

LinkDisplay.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkDisplay);



// WEBPACK FOOTER //
// ./src/app/main/link-creator/components/link-display.js